import type { ReactNode } from "react";
import { businessNode, canonical } from "./seo";

/**
 * `a` is always the plain-text answer (used for FAQPage schema).
 * `aNode` optionally overrides the rendered answer (e.g. to include a link).
 */
export type Faq = { q: string; a: string; aNode?: ReactNode };

export function serviceSchema(opts: {
  name: string;
  slug: string;
  description: string;
  serviceType?: string;
  rating?: number;
  reviewCount?: number;
}) {
  const provider = businessNode(
    typeof opts.rating === "number" && typeof opts.reviewCount === "number"
      ? {
          aggregateRating: {
            ratingValue: opts.rating.toFixed(1),
            reviewCount: String(opts.reviewCount),
          },
        }
      : {},
  );
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: opts.name,
    serviceType: opts.serviceType ?? opts.name,
    description: opts.description,
    url: canonical(opts.slug),
    provider,
    areaServed: [
      "Phoenix", "Scottsdale", "Mesa", "Paradise Valley", "Cave Creek", "Carefree",
      "Fountain Hills", "Sun City", "Peoria", "Chandler", "Tempe", "Gilbert",
      "Glendale", "Surprise", "Anthem",
    ].map((n) => ({ "@type": "City", name: n })),
  };
}

export function faqSchema(faqs: Faq[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
